export default __webpack_public_path__ + "static/media/friends-blue.3f98ab74.svg";